import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { usePageMeta } from "@/lib/seo";
import ProductCard from "@/components/shop/ProductCard";
import { PalletFinalSale } from "@/components/PalletFinalSale";

export default function PalletListPage() {
  const { type } = useParams(); // manifested | unmanifested
  const isManifested = type === "manifested";
  usePageMeta(
    `${isManifested ? "Manifested" : "Unmanifested"} Pallets | IPVALUE Marketplace`,
    `${isManifested ? "Manifested wholesale pallets with itemized contents" : "Low-cost unmanifested pallets sold as-is"} in Grand Rapids, MI.`
  );
  const [items, setItems] = useState(null);

  useEffect(() => {
    setItems(null);
    api
      .get("/products", { params: { pallet_type: type, limit: 60 } })
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]));
  }, [type]);

  return (
    <div className="max-w-[1200px] mx-auto px-6 md:px-8 py-10" data-testid={`pallet-list-${type}`}>
      <Link to="/pallets" className="text-xs text-gray-500 underline">← All pallet options</Link>
      <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tighter text-[#0A1C40] mt-2">
        {isManifested ? "Manifested Pallets" : "Unmanifested Pallets"}
      </h1>
      <p className="text-sm text-gray-600 mt-1">
        {isManifested
          ? "Manifest included · pre-built · pay the listed price."
          : "Lower cost · no complete manifest · sold AS-IS · FINAL SALE."}
      </p>
      {!isManifested && (
        <div className="mt-3 max-w-xl bg-amber-100 border-2 border-amber-500 text-amber-900 text-sm font-black px-4 py-3" data-testid="unmanifested-risk-warning">
          ⚠️ UNMANIFESTED PALLETS ARE PURCHASED AT THE BUYER'S RISK.
        </div>
      )}
      <div className="mt-4 max-w-xl"><PalletFinalSale compact /></div>

      {/* Fix #4 — Build Your Own Pallet as a primary action */}
      <Link
        to="/build-pallet"
        className="mt-5 flex flex-col sm:flex-row sm:items-center justify-between gap-3 bg-[#0A1C40] hover:bg-black transition-colors p-5 group"
        data-testid="pallet-list-builder-cta"
      >
        <div>
          <div className="font-display font-black text-xl text-[#FFC220]">Want to pick your own items? Build Your Own Pallet →</div>
          <div className="text-white/80 text-sm mt-1">
            3 items $500 · 5 items $900 · 7 items $1,500 · 11 items $2,200 — merchandise included, plus a flat $299 customization fee.
          </div>
        </div>
        <span className="shrink-0 bg-[#FFC220] text-[#0A1C40] font-black px-6 py-3 rounded-full group-hover:bg-white transition-colors text-sm">
          START BUILDING
        </span>
      </Link>

      {items === null ? (
        <div className="py-16 text-center text-gray-500">Loading…</div>
      ) : items.length === 0 ? (
        <div className="py-16 text-center text-gray-500" data-testid="pallet-list-empty">
          None available right now — call (616) 410-0158 or check back soon.
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mt-8">
          {items.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
